import { render, staticRenderFns } from "./MoleculeModificationAlertDetail.vue?vue&type=template&id=7b1f7f38&scoped=true&"
import script from "./MoleculeModificationAlertDetail.vue?vue&type=script&lang=js&"
export * from "./MoleculeModificationAlertDetail.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeModificationAlertDetail.vue?vue&type=style&index=0&id=7b1f7f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1f7f38",
  null
  
)

export default component.exports